// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2rn5g","tab":"Tabs_tab__1CaVb","tabActive":"Tabs_tabActive__2VegM"};